import { useIsLoggedIn } from "../../context/LoginContext";
import { useEffect } from "react";
import { useQueryClient } from "react-query";

export const FlushQueriesOnLogout: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!isLoggedIn) queryClient.removeQueries();
  }, [isLoggedIn, queryClient]);

  return null;
};
